module.exports = __webpack_public_path__ + "media/images/common/lp/icon-present-3e1cb929a05eb4d77f46adbbe8206b81.png";